module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_8.1bc7554d.jpg";